<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Default Checklists'"
      [canGoBack]="true"
      [customBack]="'to-dos'" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>

    @if (loaded) {
      <tidy-row [align]="'center'">
        <tidy-text
          [body]="'Set your default checklists. First we use property service default, then account service default, then property default, then account default.'" />
      </tidy-row>
      <tidy-two-column-row class="extra-bottom-padding">
        <tidy-filter
          [label]="'Property'"
          [showLabels]="true"
          [initValue]="selectedAddress?.value"
          [items]="addressItems"
          (optionChange)="changeAddress($event)" />
        <tidy-filter
          [label]="'Service'"
          [showLabels]="true"
          [initValue]="serviceItems[0].value"
          [items]="serviceItems"
          (optionChange)="changeSelectedService($event)" />
      </tidy-two-column-row>
      @if (isLoadingLists) {
        <tidy-loader />
      }
      @if (!isLoadingLists) {
        <tidy-card>
          <tidy-row class="extra-bottom-padding vertical-align-center">
            <tidy-image
              [src]="selectedService?.service_type?.icon_url"
              class="header-size" />
            <tidy-text
              [header]="'Property Service Default'" />
          </tidy-row>
          <tidy-row>
            <form [formGroup]="form">
              <tidy-select
                [label]="('Default checklist for ' | translate) + selectedService.name"
                [items]="allToDoListItems"
                [icon]="'assets/svg/list-circle-outline.svg'"
                formControlName="addressServiceDefaultList"
                [form]="form.controls.addressServiceDefaultList"
                (optionChange)="updateAddressServiceDefaultList($event)" />
            </form>
          </tidy-row>
        </tidy-card>
        <tidy-row [align]="'center'">
          <tidy-image
            [src]="'assets/img/big-down-arrow.svg'"
            class="title-size" />
        </tidy-row>
        <tidy-card>
          <tidy-row class="extra-bottom-padding vertical-align-center">
            <tidy-image
              [src]="selectedService?.service_type?.icon_url"
              class="header-size" />
            <tidy-text
              [header]="'Account Service Default'" />
          </tidy-row>
          @if (allToDoListItems?.length > 0) {
            <tidy-row>
              <form [formGroup]="form">
                <tidy-select
                  [label]="('Default list for ' | translate) + selectedService.name"
                  [items]="allToDoListItems"
                  [icon]="'assets/svg/list-circle-outline.svg'"
                  formControlName="accountServiceDefaultList"
                  [form]="form.controls.accountServiceDefaultList"
                  (optionChange)="updateAccountServiceDefaultList($event)" />
              </form>
            </tidy-row>
          }
          @if (allToDoListItems?.length == 0) {
            <tidy-row class="extra-top-padding" [align]="'center'">
              <tidy-text
                [body]="'Please create a checklist to set an account default.'" />
            </tidy-row>
          }
        </tidy-card>
        <tidy-row [align]="'center'">
          <tidy-image
            [src]="'assets/img/big-down-arrow.svg'"
            class="title-size" />
        </tidy-row>
        <tidy-card>
          <tidy-row class="extra-bottom-padding vertical-align-center">
            <tidy-image
              [src]="'assets/img/home.svg'"
              class="header-size" />
            <tidy-text
              [header]="'Property Default'" />
          </tidy-row>
          <tidy-row>
            <form [formGroup]="form">
              <tidy-select
                [label]="('Default checklist for ' | translate) + selectedAddress.viewValue"
                [items]="allToDoListItems"
                [icon]="'assets/svg/list-circle-outline.svg'"
                formControlName="addressDefaultList"
                [form]="form.controls.addressDefaultList"
                (optionChange)="updateAddressDefaultList($event)" />
            </form>
          </tidy-row>
        </tidy-card>
        <tidy-row [align]="'center'">
          <tidy-image
            [src]="'assets/img/big-down-arrow.svg'"
            class="title-size" />
        </tidy-row>
        <tidy-card>
          <tidy-row class="extra-bottom-padding vertical-align-center">
            <tidy-image
              [src]="'assets/img/account.svg'"
              class="header-size" />
            <tidy-text
              [header]="'Account Default'" />
          </tidy-row>
          @if (allToDoListItems?.length > 0) {
            <tidy-row>
              <form [formGroup]="form">
                <tidy-select
                  [label]="'Default list'"
                  [items]="allToDoListItems"
                  [icon]="'assets/svg/list-circle-outline.svg'"
                  formControlName="accountDefaultList"
                  [form]="form.controls.accountDefaultList"
                  (optionChange)="updateAccountDefaultList($event)" />
              </form>
            </tidy-row>
          }
          @if (allToDoListItems?.length == 0) {
            <tidy-row class="extra-top-padding" [align]="'center'">
              <tidy-text
                [body]="'Please create a checklist to set an account default.'" />
            </tidy-row>
          }
        </tidy-card>
        @if (isRentalClient) {
          <tidy-row [align]="'center'">
            <tidy-text
              [body]="'Pro service defaults are in beta. If you want to use defaults for a service unique to your pro or have Concierge add checklists for you please'" /><span>&nbsp;</span>
              <tidy-text
                [actionBody]="'Contact Concierge'"
                class="link"
                (action)="goToConcierge()" />
            </tidy-row>
          }
      }
    }

    @if (!loaded) {
      <ion-skeleton-text animated="true" style="height: 1000px" />
    }
  </tidy-wrapper>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}

